import CRUDServiceOperations from "./CRUDServiceOperations";

class PartyRoleService extends CRUDServiceOperations {
  getPartyRoleById(id, callback, failureCallback) {
    const url = this.getEntitiesUrl() + "/" + id;
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  getEntitiesUrl = () => {
    return this.urlFactory.partyRoles();
  };
}

export default PartyRoleService;
